module.exports = __webpack_public_path__ + "media/images/bg/hero/saska-pricing-66a1ea63cb303505592fa207c1c1ce93.webp";